import { createRouter, createWebHistory } from 'vue-router';

import Maintenance from '@ui/components/Maintenance.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/:organizationSlug/e/:threadId',
      name: 'email-checkout',
      component: () => import('@/pages/organization/email/thread.vue'),
    },
    {
      path: '/:organizationSlug/invoice/:invoiceIds',
      name: 'invoice-checkout',
      component: () => import('@/pages/organization/invoice/checkout.vue'),
    },
    {
      path: '/:organizationSlug/portal/:partnerSlug(.*)-:partnerId',
      component: () => import('@/pages/organization/portal/layout.vue'),
      children: [
        {
          path: '',
          name: 'portal',
          redirect: { name: 'portal.invoices' },
        },
        {
          path: 'invoices',
          name: 'portal.invoices',
          component: () => import('@/pages/organization/portal/invoices.vue'),
        },
        {
          path: 'payments',
          name: 'portal.payments',
          component: () => import('@/pages/organization/portal/payments.vue'),
        },
        // {
        //   path: 'credit-memos',
        //   name: 'portal.credit-memos',
        //   component: () => import('@/pages/organization/portal/credit-memos.vue'),
        // },
      ],
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: Maintenance,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (
    to.name !== 'maintenance' &&
    (process.env.STUUT_MAINTENANCE_MODE?.toLowerCase() === 'true' ||
      process.env.STUUT_MAINTENANCE_MODE === '1')
  ) {
    next({ name: 'maintenance' });
  } else {
    next();
  }
});

export default router;
